import { createQueryKeys } from "@lukemorales/query-key-factory";

/**
 * Keys used to invalidate stored cached data regarding excise stamp module
 */
export const settingsKeys = createQueryKeys("settings", {
  companyDetails: () => ({
    queryKey: ["companyDetails"],
  }),
  apiSettings: () => ({
    queryKey: ["apiSettings"],
  }),
});
